import type * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { ArticleCard } from '@xing-com/crate-career-hub-article-card';
import { CAREER_HUB_BASE_PATH } from '@xing-com/crate-career-hub-common';
import type { CareerHubArticleFragmentFragment } from '@xing-com/crate-career-hub-topics';
import { GridItem } from '@xing-com/grid';
import { IconArrowRight } from '@xing-com/icons';
import { Headline } from '@xing-com/typography';

import { ArticleBlockWrapper } from './article-block-wrapper';
import { BEWERBUNG_PAGE, UEBERSICHT_PAGE } from './constant';
import { Styled } from './topic.styles';

export type TopicType = {
  articles: (CareerHubArticleFragmentFragment | null)[];
  description: string;
  slug: string;
  title: string;
};

export const Topic: React.FC<TopicType> = ({
  articles,
  description,
  slug,
  title,
}) => {
  const url = slug === BEWERBUNG_PAGE ? UEBERSICHT_PAGE : slug;

  return (
    <>
      <header>
        <Styled.HeaderWrapper>
          <Headline size="xxlarge" noMargin>
            {title}
          </Headline>
          <Styled.TextButton
            data-qa="career-hub-more-button"
            to={`${CAREER_HUB_BASE_PATH}/${url}`}
            icon={IconArrowRight}
            iconAfter
          >
            <FormattedMessage id="CAREER_HUB_HOME_MORE_BUTTON" />
          </Styled.TextButton>
        </Styled.HeaderWrapper>
        <Styled.BodyCopy>{description}</Styled.BodyCopy>
      </header>
      <ArticleBlockWrapper>
        {articles?.map((article) =>
          article ? (
            <GridItem key={article.title} spanMedium={6} spanLarge={4}>
              <ArticleCard
                {...{
                  description: article?.description,
                  imageSrc: article?.image?.srcWide ?? '',
                  pageTitle: article?.pageTitle,
                  profileImage: article?.pageLogos?.square48 ?? '',
                  title: article?.title,
                  url: `${article?.url}?sc_o=career_hub_main_page_article_click`,
                }}
              />
            </GridItem>
          ) : null
        )}
      </ArticleBlockWrapper>
    </>
  );
};
